import { getUserToken } from '../../../../helpers/authUtils';

import { QueryingNotifications, ErrorQueryingNotifications, NotificationsReceived } from "../";

// As this is a thunk, it is a function which returns a function.
const getNotifications_thunk = (overrideTimer) => {
    return (dispatch, getState) => {
        if (!overrideTimer) {
            const currentState = getState();
            const lastRetrievalTime = currentState.Notifications.lastRetrievalTime;

            if (lastRetrievalTime) {
                const currentTime = Date.now();
                const timeSinceLastRetrieval = currentTime - lastRetrievalTime;

                if (timeSinceLastRetrieval < 60000) {
                    return;
                }
            }
        }
        
        dispatch(QueryingNotifications());

        let url = '/portal/Notifications/GetNotifications';

        let options = {
            ...{
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json',
                    'Authorization': 'Bearer ' + getUserToken()
                }
            }
        };

        fetch(url, options)
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                else {
                    throw new Error(response);
                }
            })
            .then(function (response) {
                let notifications = response;
                dispatch(NotificationsReceived(notifications));
            })
            .catch(function (errorResponse) {
                let errorMessage = errorResponse.Message;
                dispatch(ErrorQueryingNotifications(errorMessage));
            });
    };
};

export default getNotifications_thunk;